/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Container, Grid } from '@material-ui/core';
import ShopByCardInterior from './ShopByCardInterior';

const ShopByCardBuilder = ({ category }) => (
    <Grid className="root">

        <Container container sm={4} style={{ marginBottom: '1rem' }} key={category?._metadata?.uid}>

            <div className="shop-by-section">

                <h4 className="filter-title" aria-label={`SHOP BY ${category?.menu_groups?.title}`}>{category?.menu_groups?.title}</h4>

                <ShopByCardInterior category={category} />

            </div>

        </Container>

    </Grid>
);

ShopByCardBuilder.propTypes = {
    category: PropTypes.object.isRequired,
};

export default ShopByCardBuilder;
